// //alert
// function alert(message) {
//   $("body").append(
//     '<div class="alert">' +
//       '<div class="alert-overlay"></div>' +
//       '<div class="alert-box">' +
//       '<div class="alert-close aease">' +
//       '<svg viewBox="64 64 896 896" data-icon="close" width="16px" height="16px" fill="currentColor" aria-hidden="true" focusable="false">' +
//       '<path d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"></path>' +
//       "</svg>" +
//       "</div>" +
//       '<div class="alert-content">' +
//       message +
//       "</div>" +
//       '<div class="alert-btn">' +
//       '<div class="alert-btn-close aease">Close</div>' +
//       "</div>" +
//       "</div>" +
//       "</div>"
//   );
// }
// $(document).ready(function () {
//   $("body").on(
//     "click",
//     ".alert-btn-close, .alert-overlay, .alert-close",
//     function () {
//       $(".alert").remove().empty();
//     }
//   );
// });

// $(document).ready(function () {
//   if (typeof formatMoney === "undefined") {
//     function formatMoney(cents, format = "") {
//       if (typeof cents === "string") {
//         cents = cents.replace(".", "");
//       }
//       const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
//         formatString = format || window.themeVariables.settings.moneyFormat;
//       function defaultTo(value2, defaultValue) {
//         return value2 == null || value2 !== value2 ? defaultValue : value2;
//       }
//       function formatWithDelimiters(number, precision, thousands, decimal) {
//         precision = defaultTo(precision, 2);
//         thousands = defaultTo(thousands, ",");
//         decimal = defaultTo(decimal, ".");
//         if (isNaN(number) || number == null) {
//           return 0;
//         }
//         number = (number / 100).toFixed(precision);
//         let parts = number.split("."),
//           dollarsAmount = parts[0].replace(
//             /(\d)(?=(\d\d\d)+(?!\d))/g,
//             "$1" + thousands
//           ),
//           centsAmount = parts[1] ? decimal + parts[1] : "";
//         return dollarsAmount + centsAmount;
//       }
//       let value = "";
//       switch (formatString.match(placeholderRegex)[1]) {
//         case "amount":
//           value = formatWithDelimiters(cents, 2);
//           break;
//         case "amount_no_decimals":
//           value = formatWithDelimiters(cents, 0);
//           break;
//         case "amount_with_space_separator":
//           value = formatWithDelimiters(cents, 2, " ", ".");
//           break;
//         case "amount_with_comma_separator":
//           value = formatWithDelimiters(cents, 2, ".", ",");
//           break;
//         case "amount_with_apostrophe_separator":
//           value = formatWithDelimiters(cents, 2, "'", ".");
//           break;
//         case "amount_no_decimals_with_comma_separator":
//           value = formatWithDelimiters(cents, 0, ".", ",");
//           break;
//         case "amount_no_decimals_with_space_separator":
//           value = formatWithDelimiters(cents, 0, " ");
//           break;
//         case "amount_no_decimals_with_apostrophe_separator":
//           value = formatWithDelimiters(cents, 0, "'");
//           break;
//       }
//       if (formatString.indexOf("with_comma_separator") !== -1) {
//         return formatString.replace(placeholderRegex, value);
//       } else {
//         return formatString.replace(placeholderRegex, value);
//       }
//     }
//   }

//   // open or close
//   $(".pca-item-head").click(function () {
//     let parentClass = $(this).parent().attr("class");

//     if (parentClass.indexOf("-open") === -1) {
//       $(this).parent().addClass("pca-item-open");
//     } else {
//       $(this).parent().removeClass("pca-item-open");
//     }
//   });

//   // select size
//   $(
//     ".pca-size-item-select_widthInches, .pca-size-item-select_widthEighths, .pca-size-item-select_heightInches, .pca-size-item-select_heightEighths"
//   ).change(function (event) {
//     customAddPrice();
//     event.stopPropagation();
//     event.preventDefault();
//   });

//   // init option currency price
//   console.log(Shopify.currency.active, "-------------", "isoCode:", Shopify);
//   if (Shopify.currency.active != isoCode) {
//     // console.log("isoCode", isoCode);
//     $(".product-form-custom-attributes")
//       .find(".pca-radio-item-right-price, .pca-checkbox-item-right-price")
//       .each(function () {
//         let thisDataPrice = $(this).attr("data-price");
//         let thisPrice = thisDataPrice * Shopify.currency.rate;

//         $(this).attr("data-price", thisPrice);

//         thisPrice = formatMoney(thisPrice * 100);
//         $(this).text("+" + thisPrice);
//       });
//   }

//   function getPrice(width, height) {
//     const keys = Object.keys(width_height_price);

//     for (const key of keys) {
//       const [minWidth, maxWidth] = key.split("-")[0].split("_").map(Number);
//       const [minHeight, maxHeight] = key.split("-")[1].split("_").map(Number);

//       if (
//         width >= minWidth &&
//         width <= maxWidth &&
//         height >= minHeight &&
//         height <= maxHeight
//       ) {
//         return width_height_price[key];
//       }
//     }

//     return null;
//   }

//   customAddPrice();
//   function customAddPrice() {
//     // width
//     let selectedWidth = $(".pca-size-item-select_widthInches").val();
//     let width = Number(selectedWidth.replace(" Inches", ""));
//     let widthText = width;

//     // height
//     let selectedHeight = $(".pca-size-item-select_heightInches").val();
//     let height = Number(selectedHeight.replace(" Inches", ""));
//     let heughtText = height;

//     let productPrice = getPrice(width, height);
//     if (Shopify.currency.active != isoCode) {
//       productPrice = productPrice * Shopify.currency.rate;
//     }

//     // size head and value
//     let thisPcaItem = $(".pca-size").parents(".pca-item");
//     thisPcaItem.attr("id", "pca-item");

//     let selectedWidthEighths = $(".pca-size-item-select_widthEighths").val();
//     if (selectedWidthEighths != "0") {
//       widthText += " " + selectedWidthEighths + " Inches";
//     } else {
//       widthText += " Inches";
//     }
//     $(".pca-size-item-width-value").val(widthText);

//     let selectedHeightEighths = $(".pca-size-item-select_heightEighths").val();
//     if (selectedHeightEighths != "0") {
//       heughtText += " " + selectedHeightEighths + " Inches";
//     } else {
//       heughtText += " Inches";
//     }
//     $(".pca-size-item-height-value").val(heughtText);

//     thisPcaItem
//       .find(".pca-item-head-right-value")
//       .text("Width: " + widthText + " - Height: " + heughtText);

//     // radio and checkbox price
//     $(".pca-item").each(function () {
//       if ($(this).find("#pca-radio-item")[0] !== undefined) {
//         let thisRadioChecked = $(this).find("#pca-radio-item");

//         if (
//           thisRadioChecked.find(".pca-radio-item-right-price")[0] !== undefined
//         ) {
//           thisRadioPrice = Number(
//             thisRadioChecked
//               .find(".pca-radio-item-right-price")
//               .attr("data-price")
//           );
//           productPrice += thisRadioPrice;
//         }
//       }

//       if ($(this).find("#pca-checkbox-item")[0] !== undefined) {
//         $(this)
//           .find(".pca-checkbox-item")
//           .each(function () {
//             if ($(this).attr("id") !== undefined) {
//               if (
//                 $(this).find(".pca-checkbox-item-right-price")[0] !== undefined
//               ) {
//                 thisRadioPrice = Number(
//                   $(this)
//                     .find(".pca-checkbox-item-right-price")
//                     .attr("data-price")
//                 );
//                 productPrice += thisRadioPrice;
//               }
//             }
//           });
//       }
//     });

//     // price change
//     $(".ymq-price-span, .product-sticky-form__price").text();
//     $(".price, .custom-price").html(formatMoney(productPrice * 100));

//     if (Shopify.currency.active != isoCode) {
//       $(".pca-add-price").val(
//         (productPrice - startPrice) / Shopify.currency.rate
//       );
//     } else {
//       $(".pca-add-price").val(productPrice - startPrice);
//     }
//   }

//   // option select
//   $(".block-swatch__item").click(function () {
//     console.log("optionSelect");

//     setTimeout(function () {
//       customAddPrice();
//     }, 100);
//   });

//   // radio checked
//   $(".pca-radio-item").click(function () {
//     console.log("radioChecked");
//     let thisItem = $(this).parents(".pca-item");
//     if ($(this).attr("id") === undefined) {
//       // this radio checked
//       $(this).attr("id", "pca-radio-item").siblings().removeAttr("id");

//       // value
//       let thisVal = $(this).find(".pca-radio-item-left-name").text();
//       $(this)
//         .parents(".pca-item-box")
//         .children(".pca-item-box-value")
//         .val(thisVal);

//       // head infomation
//       let thisItemHead = thisItem.children(".pca-item-head");
//       thisItemHead.find(".pca-item-head-right-value").text(thisVal);

//       if ($(this).find(".pca-radio-item-right-price")[0] !== undefined) {
//         let thisDataPrice = Number(
//           $(this).find(".pca-radio-item-right-price").attr("data-price")
//         );
//         let thisDataPriceText = $(this)
//           .find(".pca-radio-item-right-price")
//           .text();

//         if (thisDataPrice > 0) {
//           thisItemHead
//             .find(".pca-item-head-right-price")
//             .text(thisDataPriceText);
//         } else {
//           thisItemHead.find(".pca-item-head-right-price").text("");
//         }
//       } else {
//         thisItemHead.find(".pca-item-head-right-price").text("");
//       }

//       // parent item checked
//       if (thisItem.attr("id") === undefined) {
//         thisItem.attr("id", "pca-item");
//       }

//       customAddPrice();
//     }
//   });

//   // checkbox checked
//   $(".pca-checkbox-item").click(function () {
//     let thisItem = $(this).parents(".pca-item");
//     console.log("checkboxChecked");
//     if ($(this).attr("id") === undefined) {
//       $(this).attr("id", "pca-checkbox-item");
//       $(this).find("input[type=checkbox]").attr("checked", "checked");
//     } else {
//       $(this).removeAttr("id");
//       $(this).find("input[type=checkbox]").removeAttr("checked");
//     }

//     // head information
//     let thisItemHead = thisItem.children(".pca-item-head");

//     let hasCheckedCount = 0;
//     let checkedPrice = 0;
//     $(this)
//       .parent()
//       .find(".pca-checkbox-item")
//       .each(function () {
//         if ($(this).attr("id") !== undefined) {
//           hasCheckedCount++;

//           if ($(this).find(".pca-checkbox-item-right-price")[0] !== undefined) {
//             checkedPrice =
//               checkedPrice +
//               Number(
//                 $(this)
//                   .find(".pca-checkbox-item-right-price")
//                   .attr("data-price")
//               );
//           }
//         }
//       });

//     if (hasCheckedCount > 0) {
//       thisItem.attr("id", "pca-item");

//       let itemText = hasCheckedCount > 1 ? " Items" : " Item";
//       thisItemHead
//         .find(".pca-item-head-right-value")
//         .text(hasCheckedCount + itemText);

//       if (checkedPrice > 0) {
//         thisItemHead
//           .find(".pca-item-head-right-price")
//           .text("+" + formatMoney(checkedPrice * 100));
//       } else {
//         thisItemHead.find(".pca-item-head-right-price").text("");
//       }
//     } else {
//       thisItem.removeAttr("id");
//       thisItemHead
//         .find(".pca-item-head-right-value, .pca-item-head-right-price")
//         .text("");
//     }

//     customAddPrice();
//   });

//   // remark
//   $(".pca-remark-input").keyup(function () {
//     if ($(this).val() != "") {
//       $(this).parent().attr("id", "pca-remark");
//     } else {
//       $(this).parent().removeAttr("id");
//     }
//   });

//   // jumap
//   $(".pca-notice-jump").click(function () {
//     let formTop = $("#contact_form").offset();
//     $(window).scrollTop(formTop.top - 300);
//   });
// });

// 使用严格模式
"use strict";

// 全局工具函数
const Utils = {
  // 格式化货币
  formatMoney: function (cents, format = "") {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }

    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString =
      format || window.themeVariables?.settings?.moneyFormat || "";

    const formatWithDelimiters = (
      number,
      precision = 2,
      thousands = ",",
      decimal = "."
    ) => {
      if (isNaN(number) || number == null) return "0";

      number = (number / 100).toFixed(precision);
      const parts = number.split(".");
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        `$1${thousands}`
      );
      const centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    };

    const formatMap = {
      amount: () => formatWithDelimiters(cents, 2),
      amount_no_decimals: () => formatWithDelimiters(cents, 0),
      amount_with_space_separator: () =>
        formatWithDelimiters(cents, 2, " ", "."),
      amount_with_comma_separator: () =>
        formatWithDelimiters(cents, 2, ".", ","),
      amount_with_apostrophe_separator: () =>
        formatWithDelimiters(cents, 2, "'", "."),
      amount_no_decimals_with_comma_separator: () =>
        formatWithDelimiters(cents, 0, ".", ","),
      amount_no_decimals_with_space_separator: () =>
        formatWithDelimiters(cents, 0, " "),
      amount_no_decimals_with_apostrophe_separator: () =>
        formatWithDelimiters(cents, 0, "'"),
    };

    const formatType = formatString.match(placeholderRegex)?.[1] || "amount";
    const value = formatMap[formatType]
      ? formatMap[formatType]()
      : formatWithDelimiters(cents, 2);

    return formatString.replace(placeholderRegex, value);
  },

  // 显示警告框
  showAlert: function (message) {
    const alertHTML = `
      <div class="alert">
        <div class="alert-overlay"></div>
        <div class="alert-box">
          <div class="alert-close aease">
            <svg viewBox="64 64 896 896" data-icon="close" width="16px" height="16px" fill="currentColor" aria-hidden="true" focusable="false">
              <path d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"></path>
            </svg>
          </div>
          <div class="alert-content">${message}</div>
          <div class="alert-btn">
            <div class="alert-btn-close aease">Close</div>
          </div>
        </div>
      </div>
    `;

    $("body").append(alertHTML);
  },
};

// 主应用类
class ProductFormCustomAttributes {
  constructor() {
    this.initElements();
    this.bindEvents();
    this.initCurrency();
    this.customAddPrice();
  }

  initElements() {
    this.$body = $('body');
    this.$pcaItems = $('.pca-item');
    this.$sizeSelects = $('.pca-size-item-select_widthInches, .pca-size-item-select_widthEighths, .pca-size-item-select_heightInches, .pca-size-item-select_heightEighths');
    this.$radioItems = $('.pca-radio-item');
    this.$checkboxItems = $('.pca-checkbox-item');
    this.$remarkInput = $('.pca-remark-input');
    this.$noticeJump = $('.pca-notice-jump');
  }

  bindEvents() {
    // 警告框关闭
    this.$body.on('click', '.alert-btn-close, .alert-overlay, .alert-close', () => {
      $('.alert').remove().empty();
    });

    // 折叠面板
    $('.pca-item-head').on('click', this.toggleItem.bind(this));

    // 尺寸选择
    this.$sizeSelects.on('change', this.handleSizeChange.bind(this));

    // 选项选择
    $('.block-swatch__item').on('click', () => {
      setTimeout(this.customAddPrice.bind(this), 100);
    });

    // 单选按钮
    this.$radioItems.on('click', this.handleRadioClick.bind(this));

    // 复选框
    this.$checkboxItems.on('click', this.handleCheckboxClick.bind(this));

    // 备注
    this.$remarkInput.on('keyup', this.handleRemarkInput.bind(this));

    // 跳转
    this.$noticeJump.on('click', this.handleNoticeJump.bind(this));
  }

  initCurrency() {
    if (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active !== isoCode) {
      $('.product-form-custom-attributes')
        .find('.pca-radio-item-right-price, .pca-checkbox-item-right-price')
        .each((index, element) => {
          const $el = $(element);
          const thisDataPrice = $el.attr('data-price');
          const thisPrice = thisDataPrice * Shopify.currency.rate;

          $el.attr('data-price', thisPrice)
             .text('+' + Utils.formatMoney(thisPrice * 100));
        });
    }
  }

  toggleItem(event) {
    const $parent = $(event.currentTarget).parent();
    $parent.toggleClass('pca-item-open');
  }

  handleSizeChange(event) {
    event.stopPropagation();
    event.preventDefault();
    this.customAddPrice();
  }

  handleRadioClick(event) {
    const $radio = $(event.currentTarget);
    if ($radio.attr('id') !== undefined) return;

    // 设置当前单选为选中状态
    $radio.attr('id', 'pca-radio-item').siblings().removeAttr('id');

    // 更新值和显示
    const thisVal = $radio.find('.pca-radio-item-left-name').text();
    const $itemBox = $radio.parents('.pca-item-box');
    const $itemHead = $radio.parents('.pca-item').children('.pca-item-head');

    $itemBox.children('.pca-item-box-value').val(thisVal);
    $itemHead.find('.pca-item-head-right-value').text(thisVal);

    // 更新价格显示
    const $priceEl = $radio.find('.pca-radio-item-right-price');
    if ($priceEl.length) {
      const thisDataPrice = Number($priceEl.attr('data-price'));
      $itemHead.find('.pca-item-head-right-price')
        .text(thisDataPrice > 0 ? $priceEl.text() : '');
    } else {
      $itemHead.find('.pca-item-head-right-price').text('');
    }

    // 标记父项
    const $parentItem = $radio.parents('.pca-item');
    if ($parentItem.attr('id') === undefined) {
      $parentItem.attr('id', 'pca-item');
    }

    this.customAddPrice();
  }

  handleCheckboxClick(event) {
    const $checkbox = $(event.currentTarget);
    const isChecked = $checkbox.attr('id') === undefined;

    // 切换选中状态
    if (isChecked) {
      $checkbox.attr('id', 'pca-checkbox-item')
              .find('input[type=checkbox]').attr('checked', 'checked');
    } else {
      $checkbox.removeAttr('id')
              .find('input[type=checkbox]').removeAttr('checked');
    }

    // 更新头部信息
    const $itemHead = $checkbox.parents('.pca-item').children('.pca-item-head');
    const $checkboxes = $checkbox.parent().find('.pca-checkbox-item');

    let hasCheckedCount = 0;
    let checkedPrice = 0;

    $checkboxes.each((index, el) => {
      if ($(el).attr('id') !== undefined) {
        hasCheckedCount++;
        const $priceEl = $(el).find('.pca-checkbox-item-right-price');
        if ($priceEl.length) {
          checkedPrice += Number($priceEl.attr('data-price'));
        }
      }
    });

    if (hasCheckedCount > 0) {
      $checkbox.parents('.pca-item').attr('id', 'pca-item');
      const itemText = hasCheckedCount > 1 ? " Items" : " Item";

      $itemHead.find('.pca-item-head-right-value')
        .text(hasCheckedCount + itemText);

      $itemHead.find('.pca-item-head-right-price')
        .text(checkedPrice > 0 ? "+" + Utils.formatMoney(checkedPrice * 100) : "");
    } else {
      $checkbox.parents('.pca-item').removeAttr('id');
      $itemHead.find('.pca-item-head-right-value, .pca-item-head-right-price').text("");
    }

    this.customAddPrice();
  }

  handleRemarkInput(event) {
    const $input = $(event.currentTarget);
    $input.parent().toggleClass('pca-remark', $input.val() !== "");
  }

  handleNoticeJump(event) {
    event.preventDefault();
    const formTop = $('#contact_form').offset();
    $(window).scrollTop(formTop.top - 300);
  }

  getPrice(width, height) {
    // console.log(window,'Shopify')
    const keys = Object.keys(width_height_price);
    for (const key of keys) {
      const [minWidth, maxWidth] = key.split('-')[0].split('_').map(Number);
      const [minHeight, maxHeight] = key.split('-')[1].split('_').map(Number);

      if (width >= minWidth && width <= maxWidth &&
          height >= minHeight && height <= maxHeight) {
        return width_height_price[key];
      }
    }

    return null;
  }

  customAddPrice() {
    try {
      // 获取宽度和高度
      const width = Number($('.pca-size-item-select_widthInches').val().replace(" Inches", ""));
      const height = Number($('.pca-size-item-select_heightInches').val().replace(" Inches", ""));

      // 计算基础价格
      let productPrice = this.getPrice(width, height) || 0;
      if (Shopify.currency.active !== isoCode) {
        productPrice *= Shopify.currency.rate;
      }

      // 更新尺寸显示
      const $sizeItem = $('.pca-size').parents('.pca-item');
      $sizeItem.attr('id', 'pca-item');

      const widthText = this.getDimensionText('width');
      const heightText = this.getDimensionText('height');

      $('.pca-size-item-width-value').val(widthText);
      $('.pca-size-item-height-value').val(heightText);
      $sizeItem.find('.pca-item-head-right-value')
        .text(`Width: ${widthText} - Height: ${heightText}`);

      // 添加选项价格
      productPrice += this.calculateOptionsPrice();

      // 更新价格显示
      $('.price, .custom-price').html(Utils.formatMoney(productPrice * 100));

      // 更新隐藏价格字段
      const priceDiff = Shopify.currency.active !== isoCode
        ? (productPrice - startPrice) / Shopify.currency.rate
        : productPrice - startPrice;
      $('.pca-add-price').val(priceDiff);

    } catch (error) {
      console.error('Error in customAddPrice:', error);
    }
  }

  getDimensionText(type) {
    const inches = $(`.pca-size-item-select_${type}Inches`).val();
    const fraction = $(`.pca-size-item-select_${type}Eighths`).val();

    return fraction !== "0"
      ? `${inches} ${fraction} Inches`
      : `${inches} Inches`;
  }

  calculateOptionsPrice() {
    let additionalPrice = 0;

    // 单选选项价格
    $('.pca-item').each((index, item) => {
      const $item = $(item);

      // 单选按钮
      const $radioItem = $item.find('#pca-radio-item');
      if ($radioItem.length) {
        const $priceEl = $radioItem.find('.pca-radio-item-right-price');
        if ($priceEl.length) {
          additionalPrice += Number($priceEl.attr('data-price'));
        }
      }

      // 复选框
      $item.find('#pca-checkbox-item').each((i, el) => {
        const $priceEl = $(el).find('.pca-checkbox-item-right-price');
        if ($priceEl.length) {
          additionalPrice += Number($priceEl.attr('data-price'));
        }
      });
    });

    return additionalPrice;
  }
}

// 文档加载完成后初始化
$(document).ready(() => {
  // 确保货币格式化函数存在
  if (typeof formatMoney === "undefined") {
    window.formatMoney = Utils.formatMoney;
  }

  // 初始化应用
  new ProductFormCustomAttributes();
});
